import { useState, useEffect } from 'react';

export interface GKToggleableInputProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

export const GKToggleableInput = (props: GKToggleableInputProps) => {
  const { value, onChange, className = '' } = props;

  const [isEditing, setIsEditing] = useState(false);

  const onBlur = (event) => {
    onChange(event.target.value ? event.target.value : 0);
    setIsEditing(false);
  };

  useEffect(() => {
    const listener = (event) => {
      // faire marcher le process avec la touche entrée
      if (
        (event.code === 'Enter' || event.code === 'NumpadEnter') &&
        isEditing === true
      ) {
        onChange(event.target.value ? event.target.value : '');
        setIsEditing(false);
      }
    };
    document.addEventListener('keydown', listener);
    return () => {
      document.removeEventListener('keydown', listener);
    };
  }, [isEditing]);

  return (
    <span className={'GKToggleableInput ' + className}>
      {isEditing ? (
        <input
          style={{ width: `${value.length * 5 + 20}px` }}
          type="text"
          defaultValue={value}
          onBlur={onBlur}
          autoFocus
        />
      ) : (
        <span onClick={() => setIsEditing(true)}>{value}</span>
      )}
    </span>
  );
};

export default GKToggleableInput;
